module.exports = __webpack_public_path__ + "img/sitting-reading.5592d1ee.svg";